<app-loader *ngIf="loading"></app-loader>
<section class="rounded-xl bg-white border border-lineGray shadow-soft p-3 sm:p-4 mb-6" *ngIf="form">
  
  <div class="flex items-center justify-between border-b border-card_Bg_Color pb-2">
    <div class="flex items-center gap-3">
      <p class="text-sm text-primary_Text_Color poppinsSemiBold">Filters</p>
      
      <!-- ✨ UPDATED: Reset Filters Button (Toggles based on having active filters) -->
      <!-- <div (click)="isActiveFilterPresent() ? onReset() : null" 
           class="w-7 h-7 border border-card_number_color rounded-lg flex items-center justify-center transition-all duration-200"
           [ngClass]="isActiveFilterPresent() ? 'cursor-pointer hover:bg-slate-50' : 'cursor-not-allowed opacity-40 grayscale'">
        <img title="Reset Filters" [src]="commonService.Images.RESET_FILTERS" class="h-3 w-3" alt="reset-filters"/>
      </div> -->
      <div  title="Reset Filters" (click)="onReset()"  class="w-7 h-7 border cursor-pointer hover:bg-[#E3E8F6] hover:border-transparent border-card_number_color rounded-lg flex items-center justify-center transition-all duration-200">
        <img [src]="commonService.Images.RESET_FILTERS" class="h-3 w-3" alt="reset-filters"/>
      </div>
    </div>
    
    <!-- ✨ UPDATED: Apply Filter Button (Toggles based on detecting a change) -->
    <button type="button" class="text-xs poppinsMedium textBasedActions" 
              [disabled]="!isChanged"
              [ngClass]="isChanged ? 'cursor-pointer' : ' !text-secondary_Light_Text_Color !cursor-not-allowed'"
              (click)="isChanged ?onApplyFilters() :null">
        Apply Filter
    </button>
  </div>
  
  <!-- Active Logic Combination Indicator (Only shows if 2+ conditions) -->
  <div *ngIf="operatorMessage" class="w-full mb-4 mt-4">
    <span class="w-full flex items-center bg-[#CCE5F1] text-primary_Text_Color border border-blue-100 px-3 py-1.5 rounded-md text-xxs poppinsMedium">
      <span class="mr-1"> <img [src]="commonService.Images.INFO_CIRCLE" alt="" class="h-3.5 w-3.5"> </span> 
      <span>{{ operatorMessage }}</span>
    </span>
  </div>

  <!-- Rest of the form remains completely intact -->
  <form [formGroup]="form">
    <div *ngFor="let ctrl of config; let isLast = last" class="mt-5"
         [ngClass]="{
           'border-b border-card_Bg_Color pb-4': ctrl.hasLineBreak && !isLast,
           'mb-4': ctrl.hasLineBreak && !isLast
         }">
      
      <label class="poppinsMedium text-gray-500 tracking-wider text-xs mb-2 block">
        {{ ctrl.label }}
        <span *ngIf="ctrl.required" class="text-red-500">*</span>
      </label>

      <div [ngSwitch]="ctrl.type">
        
        <!-- 1. CUSTOM CHECKBOX -->
        <div *ngSwitchCase="'checkbox'" class="flex items-center gap-4 flex-wrap">
          <label *ngFor="let opt of ctrl.options" class="inline-flex items-center gap-2 cursor-pointer relative">
            <div class="custom-cb-hover relative inline-flex items-center justify-center"
                 [class.custom-cb-hover--selected]="isOptionSelected(ctrl.key, opt.value)">
                <input type="checkbox" class="sr-only custom-cb-input"  [disabled]="opt.isDisabled"
                        [checked]="isOptionSelected(ctrl.key, opt.value)"
                        (change)="onCheckboxChange(ctrl.key, opt.value, $event)">

                <span class="custom-cb-box flex-shrink-0"></span>
            </div>
              <span class="text-xs poppinsMedium whitespace-nowrap" 
                    [ngClass]="isOptionSelected(ctrl.key, opt.value) ? 'text-primary_Text_Color' : 'text-my_profile_secondary_text'"
                    [class.border-b-2]="opt.isCheckBoxLabelUnderline"
                    [class]="opt.isCheckBoxLabelUnderline ? opt.checkBoxLabelUnderlineColor : ''">
                {{ opt.label }}
              </span>
          </label>
        </div>

        <!-- 2. Custom Range Slider -->
        <div *ngSwitchCase="'range'" [formGroup]="getRangeGroup(ctrl.key)">
          <div class="mt-1">
            <span class="text-xs poppinsMedium text-primary_Text_Color">
              {{ formatRangeLabel(ctrl) }}
            </span>
          </div>

          <div
            class="range-slider relative mt-2 h-7 select-none"
            [class.range-slider--disabled]="ctrl.rangeOptions?.isDisabled"
          >
            <div class="absolute left-0 right-0 top-1/2 -translate-y-1/2 h-2 rounded-full bg-slate-300"></div>
            
            <div
                 class="absolute top-1/2 -translate-y-1/2 h-1 bg-primary_Bg_Button_Color"
                 [style.left.%]="getRangeMinPercent(ctrl.key, ctrl.rangeOptions)"
                 [style.width.%]="getRangeWidth(ctrl.key, ctrl.rangeOptions)">
            </div>

            <div [ngClass]="ctrl.rangeOptions?.isDisabled ? '!border-gray-400' : 'range-thumb--min'" class="range-thumb absolute top-1/2 w-4 h-4 bg-white border-[3px] border-primary_Bg_Button_Color rounded-full z-20 pointer-events-none"
                [style.left.%]="getRangeMinPercent(ctrl.key, ctrl.rangeOptions)"
                style="transform: translate(-50%, -50%);">
            </div>

            <div [ngClass]="ctrl.rangeOptions?.isDisabled ? '!border-gray-400' : 'range-thumb--max'" class="range-thumb absolute top-1/2 w-4 h-4 bg-white border-[3px] border-primary_Bg_Button_Color rounded-full z-20 pointer-events-none shadow-md"
                [style.left.%]="getRangeMaxPercent(ctrl.key, ctrl.rangeOptions)"
                style="transform: translate(-50%, -50%);">
            </div>

            <input type="range" class="range range--min absolute inset-0 z-10 w-full opacity-0 cursor-pointer"
                   [min]="ctrl.rangeOptions?.min" [max]="ctrl.rangeOptions?.max" [step]="ctrl.rangeOptions?.step"
                   formControlName="from"
                   [attr.aria-disabled]="ctrl.rangeOptions?.isDisabled"
                   (input)="onRangeInput(ctrl.key, ctrl.rangeOptions, 'from')">
            <input type="range" class="range range--max absolute inset-0 z-20 w-full opacity-0 cursor-pointer"
                   [min]="ctrl.rangeOptions?.min" [max]="ctrl.rangeOptions?.max" [step]="ctrl.rangeOptions?.step"
                   formControlName="to"
                   [attr.aria-disabled]="ctrl.rangeOptions?.isDisabled"
                   (input)="onRangeInput(ctrl.key, ctrl.rangeOptions, 'to')">

            <div
              *ngIf="ctrl.rangeOptions?.isDisabled"
              class="absolute inset-0 z-20 cursor-not-allowed"
              aria-hidden="true"
            ></div>
          </div>
        </div>

        <!-- 3. CUSTOM DIV DROPDOWN FOR STRINGS -->
        <div *ngSwitchCase="'select-string'" class="relative">
          <div class="w-full rounded-lg border text-xs hoverShadow poppinsMedium text-slate-700 px-3 py-2  flex justify-between items-center cursor-pointer select-none"
               [ngClass]="{'ring-1 ring-transparent border-primary_Bg_Button_Color': openDropdownKey === ctrl.key,'  border-dashed border-inactive_status_text bg-card_Bg_Color cursor-not-allowed' :ctrl.isDisabled, '  cursor-pointer  border-card_number_color bg-white ':!ctrl.isDisabled}"
               (click)="toggleDropdown(ctrl.key, $event)">
            
            <div class="flex flex-wrap  gap-1 items-center flex-1">
              <ng-container *ngIf="getSelectedNamesArray(ctrl).length > 0; else placeholder">
                
                <span *ngFor="let label of getSelectedNamesArray(ctrl).slice(0, 2); let i = index" 
                  [ngClass]="label?.length >15 ?'w-32':'w-fit'"
                 class="bgBrandBlueColor  text-white px-2 py-1.5 rounded-md border border-blue-100 flex items-center min-w-0">
                 <span class="truncate flex-1">{{ label }}</span>
                  <!-- <svg (click)="removeItemForStringTypeDropdown(ctrl.key, label, $event)"
                      xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" 
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="w-3 h-3 cursor-pointer hover:text-red-200 transition-colors">
                    <path d="M18 6 6 18" />
                    <path d="m6 6 12 12" />
                  </svg> -->
                       <img (click)="removeItemForStringTypeDropdown(ctrl.key, label, $event)" [src]="commonService.Images.CROSS_ICON_FOR_FILTERS" class="w-2 h-2 mx-1" alt="remove filter" />
                </span>

                <span *ngIf="getSelectedNamesArray(ctrl).length > 2" class="bg-primary_Bg_Button_Color  text-white px-2 py-0.5 rounded-md border border-slate-200 text-xxs poppinsMedium">
                  +{{ getSelectedNamesArray(ctrl).length - 2 }}
                </span>
                <button type="button" (click)="clearSelection(ctrl.key, $event)" class="ml-auto mr-1 p-1"></button>
              </ng-container>

              <ng-template #placeholder>
                <span class="text-my_profile_secondary_text text-xs 2xl:text-sm poppinsRegular">{{ getSelectedLabel(ctrl) }}</span>
              </ng-template>
            </div>
            <img [src]="openDropdownKey === ctrl.key && !ctrl.isDisabled ? commonService.Images.DROPDOWN_ICON_NEW_UX_HOVER_PRIMARY_BLUE_THEME : commonService.Images.DROPDOWN_ICON_NEW_UX" class="w-3 h-3 transition-transform duration-200" alt="dropdown"  />
          </div>
          
          <div *ngIf="openDropdownKey === ctrl.key && !ctrl.isDisabled" 
               [ngClass]="ctrl.openDropdownUp ? 'bottom-[calc(100%+4px)]' : 'top-[calc(100%+4px)]'"
               class="absolute left-0 right-0  poppinsMedium z-20 bg-white border border-lineGray rounded-lg hoverShadowOnDropdown max-h-48 overflow-y-auto custom-scrollbar"
               (click)="$event.stopPropagation()">
               
            <div *ngIf="ctrl.isSearchInputVisible" class="p-2 sticky top-0 bg-white z-10 ">
              <div class="relative w-full flex items-center">
                <svg class="w-3.5 h-3.5 absolute left-2.5 text-slate-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input type="text" class="w-full focus:border-primary_Bg_Button_Color outline-none ring-0 shadow-none pl-8 pr-2 py-2 text-xs   placeholder:poppinsRegular border border-card_number_color rounded-md focus:outline-none f focus:ring-0 focus:ring-transparent active:ring-0 active:ring-transparent" 
                      [placeholder]="'Search ' + (ctrl?.searchPlaceHolderText ? ctrl.searchPlaceHolderText : ctrl.label )+ '...'"
                      (input)="onSearchInput(ctrl.key, $event)"
                      [value]="ctrl.searchOnJson ? (localSearchValues[ctrl.key] || '') : ''"
                      (click)="$event.stopPropagation()">
              </div>
            </div>
            <ng-container *ngIf="getDropdownOptions(ctrl).length > 0; else noDataFound1">
              <!-- <div (click)="selectOption(ctrl.key, null, $event)" class="px-3 py-2 cursor-pointer text-my_profile_secondary_text text-xxs 2xl:text-xs poppinsRegular text-xs">
                {{ ctrl.placeholder || 'Select...' }} 
              </div> -->
              <div *ngFor="let opt of getDropdownOptions(ctrl)"
                  (click)="selectOption(ctrl.key, opt, $event)" 
                  [ngClass]="isSelected(ctrl.key, opt) ?'text-primary_Bg_Button_Color':'text-my_profile_secondary_text'"
                  class="px-2 py-0.5 hover:bg-ice_blue flex items-center gap-2 poppinsMedium  cursor-pointer text-xs"
                  [class.bg-blue-50]="form.get(ctrl.key)?.value === opt">

                  <div  class="relative inline-flex items-center justify-center rounded-lg h-8 w-8" [ngClass]="{'hover:bg-ice_blue': isSelected(ctrl.key, opt)}"> 
                      <input type="checkbox" class="sr-only custom-cb-input" 
                              [checked]="isSelected(ctrl.key, opt)"
                              (change)="$event.stopPropagation(); selectOption(ctrl.key, opt, $event)">
                      <span class="custom-cb-box flex-shrink-0"></span>
                  </div>

                <!-- <input type="checkbox" class="sr-only custom-cb-input" 
                      [checked]="isSelected(ctrl.key, opt)"
                      (change)="$event.stopPropagation(); selectOption(ctrl.key, opt, $event)">
                <span class="custom-cb-box flex-shrink-0"></span> -->
                <p class="break-all  w-36">{{ opt }}</p>   
              </div>
            </ng-container>

            <ng-template #noDataFound1>
              <div class="px-3 py-2 text-gray-400 text-xs italic">
                No data found
              </div>
            </ng-template>
          </div>
        </div>

        <!-- 4. CUSTOM DIV DROPDOWN FOR OBJECTS -->
        <div *ngSwitchCase="'select-object'" class="relative">
          <div class="w-full rounded-lg border border-card_number_color text-xs hoverShadow poppinsMedium text-primary_Text_Color px-3 py-3 bg-white flex justify-between items-center cursor-pointer select-none"
              [ngClass]="{'ring-1 ring-transparent border-primary_Bg_Button_Color': openDropdownKey === ctrl.key,'  border-dashed border-inactive_status_text bg-card_Bg_Color cursor-not-allowed' :ctrl.isDisabled, '  cursor-pointer  border-card_number_color bg-white ':!ctrl.isDisabled}"
               (click)="toggleDropdown(ctrl.key, $event)">

            <div class="flex flex-wrap gap-1 items-center flex-1">
              <ng-container *ngIf="getSelectedNamesArray(ctrl).length > 0; else placeholder">
                 <span *ngFor="let label of getSelectedNamesArray(ctrl).slice(0, 2); let i = index" 
                   [ngClass]="label?.length >15 ?'w-32':'w-fit'"
                   class="bgBrandBlueColor   text-white px-2 py-1.5 rounded-md border border-blue-100 flex items-center min-w-0">
                 <span class="truncate flex-1">{{ label }}</span>
                  <!-- <svg (click)="removeItemForObjectFormatDropdown(ctrl.key, label, $event)"
                      xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" 
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="w-3 h-3 cursor-pointer hover:text-red-200 transition-colors">
                    <path d="M18 6 6 18" />
                    <path d="m6 6 12 12" />
                  </svg> -->
                  <img (click)="removeItemForObjectFormatDropdown(ctrl.key, label, $event)" [src]="commonService.Images.CROSS_ICON_FOR_FILTERS" class="w-2 h-2 mx-1" alt="remove filter" />
                </span>
                <span *ngIf="getSelectedNamesArray(ctrl).length > 2" class="bg-primary_Bg_Button_Color text-white px-2 py-0.5 rounded-md border border-slate-200 text-xxs poppinsMedium">
                  +{{ getSelectedNamesArray(ctrl).length - 2 }}
                </span>
                <button type="button" (click)="clearSelection(ctrl.key, $event)" class="ml-auto mr-1 p-1"></button>
              </ng-container>
              <ng-template #placeholder>
                <span class="text-my_profile_secondary_text text-xs 2xl:text-sm poppinsRegular">{{ getSelectedLabel(ctrl) }}</span>
              </ng-template>
            </div>
            <img [src]="openDropdownKey === ctrl.key && !ctrl.isDisabled ? commonService.Images.DROPDOWN_ICON_NEW_UX_HOVER_PRIMARY_BLUE_THEME : commonService.Images.DROPDOWN_ICON_NEW_UX" class="w-3 h-3 transition-transform duration-200" alt="dropdown"  />
          </div>
          
          <div *ngIf="openDropdownKey === ctrl.key  && !ctrl.isDisabled" 
               [ngClass]="ctrl.openDropdownUp ? 'bottom-[calc(100%+4px)]' : 'top-[calc(100%+4px)]'"
               class="absolute left-0 right-0 z-20 bg-white border border-lineGray hoverShadowOnDropdown rounded-lg shadow-lg max-h-48 overflow-y-auto custom-scrollbar"
               (click)="$event.stopPropagation()">
            
            <div *ngIf="ctrl.isSearchInputVisible" class="p-2 sticky top-0 bg-white z-10 border-b border-card_number_color">
              <div class="relative w-full flex items-center">
                <svg class="w-3.5 h-3.5 absolute left-2.5 text-slate-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input type="text" class="w-full focus:border-primary_Bg_Button_Color outline-none ring-0  shadow-none pl-8 pr-2 py-2 text-xs   placeholder:poppinsRegular border border-card_number_color rounded-md focus:outline-none  focus:ring-0 focus:ring-transparent active:ring-0 active:ring-transparent" 
                      [placeholder]="'Search ' + (ctrl?.searchPlaceHolderText ? ctrl.searchPlaceHolderText : ctrl.label ) + '...'"
                      (input)="onSearchInput(ctrl.key, $event)"
                      [value]="ctrl.searchOnJson ? (localSearchValues[ctrl.key] || '') : ''"
                      (click)="$event.stopPropagation()">
              </div>
            </div>
            <ng-container *ngIf="getDropdownOptions(ctrl).length > 0; else noDataFound2">
              <div (click)="selectOption(ctrl.key, null, $event)" class="px-3 py-2 poppinsMedium text-gray-500 hover:bg-slate-50 cursor-pointer text-xs">
                {{ ctrl.placeholder || 'Select...' }}
              </div>
              <div *ngFor="let opt of getDropdownOptions(ctrl)"
                   (click)="selectOption(ctrl.key, opt[ctrl.valueKey || 'id'], $event)" 
                    [ngClass]="isSelected(ctrl.key, opt) ?'text-primary_Bg_Button_Color':'text-my_profile_secondary_text'"
                   class="px-3 py-2 hover:bg-ice_blue flex items-center gap-3  poppinsMedium  cursor-pointer text-xs"
                   [class.bg-blue-50]="form.get(ctrl.key)?.value === opt[ctrl.valueKey || 'id']">

                   <!-- <input type="checkbox" class="sr-only custom-cb-input" 
                     [checked]="isSelected(ctrl.key, opt[ctrl.valueKey || 'id'])"
                     (change)="$event.stopPropagation(); selectOption(ctrl.key, opt[ctrl.valueKey || 'id'], $event)">
                <span class="custom-cb-box flex-shrink-0"></span> -->

                <div  class="relative inline-flex items-center justify-center rounded-lg h-8 w-8" [ngClass]="{'hover:bg-ice_blue': isSelected(ctrl.key, opt[ctrl.valueKey || 'id'])}"> 
                      <input type="checkbox" class="sr-only custom-cb-input" 
                               [checked]="isSelected(ctrl.key, opt[ctrl.valueKey || 'id'])"
                             (change)="$event.stopPropagation(); selectOption(ctrl.key, opt[ctrl.valueKey || 'id'], $event)">
                      <span class="custom-cb-box flex-shrink-0"></span>
                  </div>
                  <p class="break-all w-36">{{ opt[ctrl.displayKey || 'name'] }}</p>
              </div>
            </ng-container>
            <ng-template #noDataFound2>
              <div class="px-3 py-2 text-gray-400 text-xs italic">
                No data found
              </div>
            </ng-template>
          </div>
        </div>

        <!-- 5. CUSTOM RADIO -->
        <div *ngSwitchCase="'radio'" class="flex flex-wrap gap-4 text-xs">
          <label *ngFor="let opt of ctrl.options" class="inline-flex items-center gap-2 cursor-pointer">
             <div  class="relative inline-flex items-center justify-center rounded-lg h-8 w-8" [ngClass]="{'hover:bg-[#D7DEF2]': isOptionSelected(ctrl.key, opt.value)}">
               <input type="radio" [formControlName]="ctrl.key" [value]="opt.value" [disabled]="ctrl.isDisabled" class="sr-only custom-radio-input">
               <span class="custom-radio-circle"></span>
             </div>
            <span class="text-slate-700 font-medium whitespace-nowrap">{{ opt.label }}</span>
          </label>
        </div>

         <!-- 6. Text Input -->
        <div *ngSwitchCase="'text'">
          <input type="text" appAppNoSpaces [formControlName]="ctrl.key" [placeholder]="ctrl.placeholder || 'Search...'"
                class="w-full rounded-lg border border-lineGray text-xs poppinsLight text-primary_Text_Color px-3 py-2 focus:outline-none focus:border-brandBlue focus:ring-1 focus:ring-brandBlue">
        </div>

        <!-- 7. Date Input -->
        <div *ngSwitchCase="'date'" class="relative">
          <app-date-time-picker 
            [fontFamily]="'poppinsRegular'"
            [formControlName]="ctrl.key" 
            mode="date" 
            [cssClass]="'px-3 py-2.5  hoverShadow outline-none ring-0 shadow-none border  staffing-newux-styles dateBadgeStyles placeholder:text-my_profile_secondary_text  text-my_profile_secondary_text !text-xs 2xl:!text-sm'"
            [isDisabled]="false"
            [placeholder]="ctrl?.placeholder">
          </app-date-time-picker>
        </div>

        <!-- 8. Date Time local Input  -->
         <div *ngSwitchCase="'datetime-local'" class="relative">
          <input type="datetime-local" [formControlName]="ctrl.key" 
          class="w-full rounded-lg border border-lineGray text-sm placeholder:text-my_profile_secondary_text  text-my_profile_secondary_text poppinsMedium px-3 py-3 hoverShadow focus:outline-none focus:border-brandBlue focus:ring-1 focus:ring-brandBlue">
        </div>
        
      </div>
      
      <ng-container *ngIf="form.get(ctrl.key)?.invalid && form.get(ctrl.key)?.touched">
        <small class="text-red-500 text-[10px] mt-1 block" *ngIf="form.get(ctrl.key)?.errors?.['required']">
          This field is required
        </small>
        <small class="text-red-500 text-[10px] mt-1 block" *ngIf="form.get(ctrl.key)?.errors?.['pattern']">
          {{ ctrl.patternErrorMessage || 'Invalid format' }}
        </small>
      </ng-container>
    </div>
  </form>
</section>
